export default {
  props: {
    showSummary: {
      type: Boolean,
      default: false
    },
    inDialog: {
      type: Boolean,
      default: false
    },
    showQuery: {
      type: Boolean,
      default: true
    },
    showCheckbox: {
      type: Boolean,
      default: true
    },
    expandQuery: {
      type: Boolean,
      default: true
    },
    page: {
      type: Boolean,
      default: true
    },
    orderField: {
      type: String,
      default: ""
    },
    orderDesc: {
      default: null
    },
    showToolbar: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showStatus: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
    }
  },
  computed: {
    refList() {
      if (!this.$refs.list) {
        alert("请在List公共组件上指定ref=\"list\"");
      }
      return this.$refs.list;
    },
  },
  methods: {
    getDataOnce(params) {
      return this.refList.getDataOnce(params);
    },
    getData(params) {
      return this.refList.getData(params);
    },
    setData(data) {
      this.refList.setData(data);
    },
    reload() {
      return this.refList.getData();
    },
    query(params) {
      return this.refList.query(params);
    },
    getCheckedRows() {
      return this.refList.getCheckedRows();
    },
    getTreeSelectRows() {
      return this.refList.getTreeSelectRows();
    },
    getCheckedRowsWithMessage() {
      return this.refList.getCheckedRowsWithMessage();
    },
    getCheckedRowWithMessage() {
      return this.refList.getCheckedRowWithMessage();
    },
    clear() {
      this.refList.clear();
    },
    delete(row = null) {
      return this.refList.delete(row);
    },
    deleteBatch() {
      return this.refList.deleteBatch();
    }
  }
}